import { EmptyState } from '@/components/ui/empty-state'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table'
import type { ImportRowError } from './types'

export function RowErrorsTable({ errors }: { errors: ImportRowError[] }) {
  if (errors.length === 0) {
    return <EmptyState title="No row errors" className="min-h-0 py-6" />
  }

  return (
    <div className="overflow-hidden rounded-md border border-border">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead className="w-20">Row</TableHead>
            <TableHead>Reason</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {errors.map((error) => (
            <TableRow key={`${error.row_number}-${error.reason}`}>
              <TableCell className="text-muted-foreground">{error.row_number}</TableCell>
              <TableCell>{error.reason}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  )
}
